module.exports = __webpack_public_path__ + "static/img/14.040631a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/travelpolicy/14.jpg
// module id = 9yaM
// module chunks = 0